import { useTranslation } from 'react-i18next';
import type { EnterpriseWorkspace } from 'v5/api/enterprise/enterprise.api';
import { MountElementProps } from 'v5/messages/mount-element';
import { TransferToWorkspaceDialog } from 'v5/patterns/forms/dialogs/TransferToWorkspaceDialog';
import { WithServices } from 'v5/platform/ts/services';
import { WithEnterpriseService } from 'v5/services/io/EnterpriseService/EnterpriseService';

export type TransferResourceDialogProps = MountElementProps &
  WithServices<[WithEnterpriseService]> & {
    organizationId: string;
    resourceName: string;
    resourceCount?: number;
    currentWorkspaceId?: number | null;
    onSubmit: (workspace: EnterpriseWorkspace) => Promise<void>;
  };

export function TransferResourceDialog({
  resourceName,
  resourceCount,
  ...props
}: TransferResourceDialogProps) {
  const { t } = useTranslation('resources', {
    keyPrefix: 'TransferResourceDialog'
  });

  const descriptionMessage = t('description', {
    count: resourceCount,
    name: resourceName
  });

  return (
    <TransferToWorkspaceDialog
      {...props}
      titleMessage={t('title')}
      descriptionMessage={descriptionMessage}
      fieldWorkspaceMessage={t('fieldWorkspace')}
    />
  );
}
